import Vue from 'vue';
import Router from 'vue-router';
import NotFound from '@/components/views/NotFound';
// Account
import Login from '@/components/views/Login';
import Register from '@/components/views/Register';
import Account from '@/components/views/Account';
import AccountProfile from '@/components/views/AccountProfile';
import AccountAddress from '@/components/views/AccountAddress';
import AccountBankAccount from '@/components/views/AccountBankAccount';
import AccountSettings from '@/components/views/AccountSettings';
// Orders
import Orders from '@/components/views/Orders';
// import OrdersLive from '@/components/views/OrdersLive';
// import OrdersHistory from '@/components/views/OrdersHistory';
import Rentals from '@/components/views/Rentals';
import RentalsLive from '@/components/views/RentalsLive';
import RentalsReturned from '@/components/views/RentalsReturned';
import RentalsHistory from '@/components/views/RentalsHistory';
import Payouts from '@/components/views/Payouts';
import PayoutsHistory from '@/components/views/PayoutsHistory';
import PayoutHistory from '@/components/views/PayoutHistory';
// Admin
import Home from '@/components/views/Home';
import Dashboard from '@/components/views/Dashboard';
import Help from '@/components/views/Help';
import Config from '@/components/views/Config';
import Staff from '@/components/views/Staff';
import CreateAccount from '@/components/views/CreateAccount';
import Customers from '@/components/views/Customers';
import Art from '@/components/views/Art';
import Piece from '@/components/views/Piece';
import SubmitOk from '@/components/views/SubmitOk';
import Terms from '@/components/views/Terms';
import ResetPassword from '@/components/views/ResetPassword';

import store from '@/store';

// Big load. So segmented.
const Reports = () => import(/* webpackChunkName: "contact" */ '@/components/views/Reports');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { layout: 'layout-full' },
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: { layout: 'layout-full' },
    },
    {
      path: '/account',
      component: Account,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
      children: [
        {
          path: 'profile',
          name: 'AccountProfile',
          component: AccountProfile,
          meta: {
            layout: 'layout-service',
            authRequired: true,
          },
        },
        {
          path: 'address',
          name: 'AccountAddress',
          component: AccountAddress,
          meta: {
            layout: 'layout-service',
            authRequired: true,
          },
        },
        {
          path: 'bank-account',
          name: 'AccountBankAccount',
          component: AccountBankAccount,
          meta: {
            layout: 'layout-service',
            authRequired: true,
          },
        },
        {
          path: 'settings',
          name: 'AccountSettings',
          component: AccountSettings,
          meta: {
            layout: 'layout-service',
            authRequired: true,
          },
        },
      ],
    },
    {
      path: '/orders',
      name: 'Orders',
      component: Orders,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
      // children: [
      //   {
      //     path: 'live',
      //     name: 'OrdersLive',
      //     component: OrdersLive,
      //     meta: {
      //       layout: 'layout-service',
      //       authRequired: true,
      //     },
      //   },
      //   {
      //     path: 'history',
      //     name: 'OrdersHistory',
      //     component: OrdersHistory,
      //     meta: {
      //       layout: 'layout-service',
      //       authRequired: true,
      //     },
      //   },
      // ],
    },
    {
      path: '/rentals',
      component: Rentals,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
      children: [
        {
          path: 'live',
          name: 'RentalsLive',
          component: RentalsLive,
          meta: {
            layout: 'layout-service',
            authRequired: true,
          },
        },
        {
          path: 'returned',
          name: 'RentalsReturned',
          component: RentalsReturned,
          meta: {
            layout: 'layout-service',
            authRequired: true,
          },
        },
        {
          path: 'history',
          name: 'RentalsHistory',
          component: RentalsHistory,
          meta: {
            layout: 'layout-service',
            authRequired: true,
          },
        },
      ],
    },
    {
      path: '/payouts',
      component: Payouts,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
      children: [
        {
          path: 'history',
          name: 'PayoutsHistory',
          component: PayoutsHistory,
          meta: {
            layout: 'layout-service',
            authRequired: true,
          },
        },
      ],
    },
    {
      path: '/payouts/history/:payoutId',
      name: 'PayoutHistory',
      component: PayoutHistory,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        layout: 'layout-app',
      },
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {
        layout: 'layout-app',
      },
    },
    {
      path: '/configuration',
      name: 'Config',
      component: Config,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
    {
      path: '/reports',
      name: 'Reports',
      component: Reports,
      meta: { layout: 'layout-service' },
    },
    {
      path: '/art',
      name: 'Art',
      component: Art,
      meta: { layout: 'layout-service' },
    },
    {
      path: '/piece/:pieceId?',
      name: 'Piece',
      component: Piece,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
    {
      path: '/submit-ok',
      name: 'SubmitOk',
      component: SubmitOk,
      meta: { layout: 'layout-service' },
    },
    {
      path: '/customers',
      name: 'Customers',
      component: Customers,
      meta: { layout: 'layout-service' },
    },
    {
      path: '/staff',
      name: 'Staff',
      component: Staff,
      meta: { layout: 'layout-service' },
    },
    {
      path: '/create-account',
      name: 'CreateAccount',
      component: CreateAccount,
      meta: { layout: 'layout-service' },
    },
    // Example of dynamic route matching
    // {
    //   path: '/invoice/:orderId',
    //   name: 'Invoice',
    //   component: Invoice,
    //   meta: {
    //     layout: 'layout-service',
    //     authRequired: true,
    //   },
    // },
    {
      path: '*',
      name: 'notfound',
      component: NotFound,
      meta: {
        layout: 'layout-full',
        authRequired: true,
      },
    },
  ],
});

// eslint-disable-next-line consistent-return
router.beforeEach((to, from, next) => {
  if (from.name !== 'login') {
    store.commit('account/setFromUrl', from.path);
  }
  // Set view layout
  store.commit('layout/setLayout', to.meta.layout);
  // Authenticate
  const authRequired = to.matched.some(record => record.meta.authRequired);
  const loggedIn = localStorage.getItem('user');
  // Route
  if (!loggedIn && authRequired) {
    // Save url user was going to, to continue there after login
    store.commit('account/setToUrl', to.path);
    return next('/login');
  }
  next();
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js